import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-safety-policy',
  imports: [],
  templateUrl: './safety-policy.component.html',
  styleUrl: './safety-policy.component.css',
})
export class SafetyPolicyComponent {
constructor(private router: Router) {
    this.lastUpdated = new Date().toLocaleDateString();
  }
  
  lastUpdated: string;

  goBack(): void {
    this.router.navigate([""]);
  }
}
